import {PageManager} from "./PageManager";
import {SingleEvent} from "shared/core/Events/SingleEvent";
import {DocumentManagerOptions, FieldSettingsOptions} from "./DocumentManager.Options";
import {AnnotationManager} from "./AnnotationManager";
import {WpAjaxPost} from "shared/core/ajax/WPAjaxPost";
import {ToastService} from "shared/core/services/ToastService";
import {Simulate} from "react-dom/test-utils";
import {PDFDocument, PDFTextField} from "PDFLib/api";
import {PDFWriter} from "PDFLib/core";
import JSONWriter from "PDFLib/core/writers/JSONWriter/JSONWriter";
let React = require("react");
declare let pdfjsLib:any;
require('../../../../lib/PDFJS/pdf.worker.entry');
let pdfjsLib2=require('../../../../lib/PDFJS/pdf');
import './DocumentManager.css';
import pako from 'pako';
import {AddFieldManager} from "../AddFieldManager/AddFieldManager";
import {TextField} from "@material-ui/core";

export class DocumentManager{
    public Pages:PageManager[];

    public SelectedPage:PageManager;
    public DocumentObject:any;
    public Options:DocumentManagerOptions;
    public FormORPDFChanged:SingleEvent;
    public RefreshDesignerTab:SingleEvent;
    public SelectedPageChanged:SingleEvent<PageManager>;
    public SelectedPageIndex:number=-1;
    public SelectedPDFFieldChanged:SingleEvent<AnnotationManager>;

    public File:File;
    public FileList:FileList;
    public PDFFields:AnnotationManager[];

    public Document:PDFDocument;
    public PDFContainer:HTMLDivElement;
    public Canvas:HTMLCanvasElement;
    public LoadingPDF:boolean;
    public LoadingPDFError:any;
    public SelectedTab:'Fields';
    public SelectedPDFField:AnnotationManager;
    public AddFieldManager:AddFieldManager;

    constructor() {
        this.Pages=[];
        this.SelectedPageChanged=new SingleEvent<PageManager>();
        this.SelectedPage=null;
        this.LoadingPDF=false;
        this.LoadingPDFError=null;
        this.SelectedTab='Fields';
        this.SelectedPDFField=null;
        this.AddFieldManager=new AddFieldManager(this);


        let options=null;
        this.RefreshDesignerTab=new SingleEvent<any>();
        this.Options=new DocumentManagerOptions().Merge(rnImporterVar.TemplateData);
        if(this.Options.Id>0) {
            this.LoadPDF(this.Options.Id);

        }

        this.FormORPDFChanged=new SingleEvent<any>();
        this.SelectedPDFFieldChanged=new SingleEvent<AnnotationManager>();

        for(let form of rnImporterVar.FormList)
        {
            form.Fields=JSON.parse(form.Fields as any);
            form.Notifications=JSON.parse(form.Notifications as any);
        }



        this.PDFFields=[];

    }

    public SetSelectedPDFField(field:AnnotationManager)
    {
        if(this.SelectedPDFField!=field) {
            this.SelectedPDFField = field;
            if(this.SelectedTab!= 'Fields')
            {
                this.SelectedTab='Fields';
                this.RefreshDesignerTab.Publish();
            }

        }
        this.SelectedPDFFieldChanged.Publish();


    }

    public GetFieldSettingsByPDFFieldId(id)
    {
        return this.Options.FieldSettings.find(x=>x.Id==id);
    }

    private async LoadDocumentObject(documentObject)
    {
        this.DocumentObject=documentObject;
        this.Pages=[];
        this.PDFFields=[];
        this.SelectedPage=null;

        for(let i=0;i<this.DocumentObject.numPages;i++)
        {
            this.Pages.push(await new PageManager(this,i,this.Document).InitializePage())

        }



        this.Pages.forEach(page=>page.Annotations.forEach(annotation=>this.PDFFields.push(annotation)));
        this.SyncFieldSettings();
        this.LoadingPDFError=null;
        return this;
    }

    public async InitializeDocument(array:any)
    {
        this.Document = await PDFDocument.load(array);
        this.ClearDocument();
        await this.LoadDocumentObject(await pdfjsLib2.getDocument(await this.Document.save({useObjectStreams: false})).promise);
        await this.SetSelectedPage(0);

    }

    public async RefreshDocument()
    {
        let previouslySelectedfield=this.SelectedPDFField;
        await this.LoadDocumentObject(await pdfjsLib2.getDocument(await this.Document.save({useObjectStreams: false})).promise);
        if(this.Document.getPageCount()>this.SelectedPageIndex)
            await this.SetSelectedPage(this.SelectedPageIndex);
        else
            await this.SetSelectedPage(0);
        if(previouslySelectedfield!=null) {
            this.SetSelectedPDFField(this.PDFFields.find(x => x.Id == previouslySelectedfield.Id))
        }

    }

    public async SetSelectedPage(pageIndex)
    {
        if(this.Pages.length==0)
            return;

        if(this.SelectedPage!=null&&this.SelectedPage.Index==pageIndex)
            return;
        this.SelectedPageIndex=pageIndex;
        this.SelectedPage=this.Pages[Math.max(0, Math.min(this.Pages.length-1,pageIndex))];
        await this.RefreshCanvas();
        this.SelectedPageChanged.Publish(this.SelectedPage);
    }

    public SetPDFFileName(name:string)
    {
        this.Options.PDFName=name;
        this.FormORPDFChanged.Publish();
    }

    public SetPDFFileURL(url:string)
    {
        this.Options.PDFURL=url;
    }

    public SetFormId(formId)
    {
        this.Options.FormId=formId;
        this.FormORPDFChanged.Publish();
    }

    public GetFields():any[]{
        let form=rnImporterVar.FormList.find(x=>x.Id==this.Options.FormId);
        if(form==null)
            return [];

        return form.Fields;
    }




    GetPDFFieldById(PDFFieldName: string) {
        return this.PDFFields.find(x=>x.AnotationObject.fieldName==PDFFieldName);
    }

    async ScrollToField(annotationManager: AnnotationManager) {
        if(annotationManager==null)
            return;

        let page=annotationManager.Page;
        let coordinates=annotationManager.GetDimension();

        if(page!=this.SelectedPage)
        {
            await this.SetSelectedPage(page.Index);
        }

        if(this.PDFContainer!=null)
        {
            let scrollTop=this.PDFContainer.scrollTop+30;
            let newScroll=Math.max(0,coordinates.Top);
            let newScrollLeft=Math.max(0,coordinates.Left+30);

            let scrollLeft=this.PDFContainer.scrollLeft;
            if(scrollTop>newScroll||scrollTop+this.PDFContainer.getBoundingClientRect().height<newScroll)
                this.PDFContainer.scrollTop=newScroll;

            if(scrollLeft>newScrollLeft||scrollLeft+this.PDFContainer.getBoundingClientRect().width<newScrollLeft)
                this.PDFContainer.scrollLeft=newScrollLeft-10;

        }


    }

    async RefreshCanvas() {
        if(this.SelectedPage!=null&&this.Canvas!=null)
            await this.SelectedPage.LoadInCanvas(this.Canvas);

    }

    async GetPDFObjects(){
        let wrtter=JSONWriter.forContext(this.Document.context,50,this.Document);
        return await wrtter.ToObject();
    }

    async Save(){
        if(this.Document==null)
        {
            ToastService.SendErrorMessage('Please import a pdf before saving');
            return;
        }

       let obj=await this.GetPDFObjects();


        if(this.Options.TemplateName.trim()=='')
        {
            ToastService.SendErrorMessage('Template name is mandatory');
            return;
        }


        let result=await WpAjaxPost.Post('Save',{Options:this.GetOptions().ToObject(),PDF:obj},null);

        if(result!=null)
        {
            ToastService.SendSuccess('Template saved successfully');
            this.Options.Id=result.Id;
            window.history.replaceState({},document.title,rnImporterVar.DesignerURL+'&templateId='+result.Id);
        }

    }

    GetOptions(){
        let options=this.Options;
        return options;
    }


    private async LoadPDF(Id: any) {
        this.LoadingPDF=true;
        this.SelectedPageChanged.Publish();


        try {

            let data=await fetch(rnImporterVar.ajaxurl+'?action='+rnImporterVar._prefix+'_'+'GetPDF'+'&data='+JSON.stringify({TemplateId:Id})+'&_nonce='+rnImporterVar._nonce);

            let response=await data.arrayBuffer();
            let array=new Uint8Array(response);

            if(array.find(x=>x!=10)!=37)
            {
                let str='';
                array.forEach(x=>str+=String.fromCharCode(x));
                let jsonResponse=null;
                try{
                    jsonResponse=JSON.parse(str);
                }catch(e)
                {
                    this.LoadingPDFError=<span>PDF could not be loaded, error:{str}</span>;
                    return;
                }

                if(jsonResponse.success===false)
                    this.LoadingPDFError=<span>There was an error wile trying to load the pdf:{jsonResponse.errorMessage}</span>
                else
                    this.LoadingPDFError=<span>PDF could not be loaded, error:{jsonResponse}</span>;

            }else {
                this.Document = await PDFDocument.load(array);
                this.ClearDocument();
                await this.LoadDocumentObject(await pdfjsLib2.getDocument(await this.Document.save({useObjectStreams: false})).promise);
              //  this.RefreshDocument();

                await this.SetSelectedPage(0);
            }


        }catch(e)
        {
            console.error(e);
            this.LoadingPDFError=<span>PDF could not be loaded</span>;
        }

        this.LoadingPDF=false;
        this.SelectedPageChanged.Publish();

    }

    private SyncFieldSettings() {
        for(let i=0;i<this.Options.FieldSettings.length;i++)
        {
            if(!this.PDFFields.some(x=>x.Id==this.Options.FieldSettings[i].Id)) {
                this.Options.FieldSettings.splice(i, 1);
                i--;
            }

        }

        for(let currentField of this.PDFFields)
        {
            if(!this.Options.FieldSettings.some(x=>x.Id==currentField.Id))
                this.Options.FieldSettings.push(new FieldSettingsOptions().Merge({Id:currentField.Id}));
        }
    }

    AddField(fieldId:string,x:number,y:number,width:number,height:number) {
        this.SelectedPage.AddField(fieldId,x,y,width,height);
    }

    private ClearDocument() {
        if(this.Document!=null)
        {
            this.Document.getForm().getFields().forEach(x=>{
                if(x instanceof PDFTextField) {
                    x.setText('');
                }
            });
        }
    }
}